"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../helpers/api.js");
var _createAction = require("../helpers/createAction.js");
var _constants = require("../constants");
var Users = /*#__PURE__*/_createClass(function Users(api) {
  var _this = this;
  _classCallCheck(this, Users);
  this.getUserUpdateKey = function (userId) {
    return "user-update/".concat(userId);
  };
  this.userUpdate = (0, _createAction.createApiRequestAction)({
    getKey: this.getUserUpdateKey,
    request: function request(getState, userId, userData) {
      return _this.api.patch("users/".concat(userId), {
        user: userData
      });
    },
    loadedConstant: _constants.USER_UPDATED,
    errorConstant: _constants.USER_ERROR,
    loadingConstant: _constants.USER_LOADING
  });
  this.getUserSubscriptionKey = function (userId) {
    return "subscriptions/".concat(userId);
  };
  this.userSubscriptionsFetch = function (userIdOverride) {
    return function (dispatch, getState) {
      var _getState = getState(),
        session = _getState.session,
        loading = _getState.loading;
      var userId = userIdOverride || session.get('current_user_id');
      var key = _this.getUserSubscriptionKey(userId);
      if (loading.has(key)) return loading.get(key);
      /* TODO: Check if the userIdOverride actually works here or is used anywhere.
               It looks like it is only partially implemented, because of the currentUserUrl Call on the promise.
      */
      var promise = _this.api.get("".concat((0, _api.currentUserUrl)(getState()), "/subscriptions")).then(function (response) {
        dispatch({
          type: _constants.USER_SUBSCRIPTIONS_FETCHED,
          payload: _objectSpread({
            key: key
          }, response)
        });
        return response;
      }).catch(function (error) {
        dispatch({
          type: _constants.USER_ERROR,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.USER_LOADING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getUserSubscriptionActivateKey = function (userId) {
    return "subscriptions-activate/".concat(userId);
  };
  this.userSubscriptionActivate = function (subscriptionId) {
    return function (dispatch, getState) {
      var _getState2 = getState(),
        session = _getState2.session,
        loading = _getState2.loading;
      var userId = session.get('current_user_id');
      var key = _this.getUserSubscriptionActivateKey(userId);
      if (loading.has(key)) return loading.get(key);
      var promise = _this.api.post("".concat((0, _api.currentUserUrl)(getState()), "/subscriptions/activate"), {
        subscriptionId: subscriptionId
      }).then(function (response) {
        dispatch({
          type: _constants.USER_SUBSCRIPTION_ACTIVATED,
          payload: _objectSpread({
            key: key
          }, response)
        });
        return response;
      }).catch(function (error) {
        dispatch({
          type: _constants.USER_ERROR,
          payload: {
            error: error,
            key: key
          }
        });
        throw error;
      });
      dispatch({
        type: _constants.USER_LOADING,
        payload: {
          key: key,
          promise: promise
        }
      });
      return promise;
    };
  };
  this.getUserFeedbackKey = function () {
    return 'user-feedback-submitting';
  };
  this.userFeedback = (0, _createAction.createApiRequestAction)({
    getKey: this.getUserFeedbackKey,
    request: function request(getState, userId, questionBankId, content, feedbackType, mobileOS, mobileBuild, mobileVersion) {
      var country = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
      var state = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
      return _this.api.post("users/".concat(userId, "/feedback"), {
        feedback: {
          question_bank_id: questionBankId,
          message: content,
          feedback_type: feedbackType,
          mobile_os: mobileOS,
          mobile_build: mobileBuild,
          mobile_version: mobileVersion,
          country: country,
          state: state
        }
      });
    },
    loadedConstant: _constants.GENERAL_FEEDBACK_SUBMITTED,
    errorConstant: _constants.GENERAL_FEEDBACK_ERROR,
    loadingConstant: _constants.GENERAL_FEEDBACK_SUBMITTING
  });
  this.getUserConfirmationEmailKey = function () {
    return "user-confirmation-sending";
  };
  this.resendConfirmationEmail = (0, _createAction.createApiRequestAction)({
    getKey: this.getUserConfirmationEmailKey,
    request: function request(getState, userId) {
      return _this.api.get("users/".concat(userId, "/resend_confirmation_email/"));
    },
    loadedConstant: _constants.USER_CONFIRMATION_EMAIL_SENT,
    errorConstant: _constants.USER_CONFIRMATION_EMAIL_SENDING_ERROR,
    loadingConstant: _constants.USER_CONFIRMATION_EMAIL_SENDING
  });
  this.getUserResetPasswordKey = function () {
    return 'user-reset-password';
  };
  this.userResetPassword = (0, _createAction.createApiRequestAction)({
    getKey: this.getUserResetPasswordKey,
    request: function request(getState, userId, currentPassword, password, passwordConfirmation) {
      return _this.api.post("users/".concat(userId, "/account-password-reset"), {
        user: {
          current_password: currentPassword,
          password: password,
          password_confirmation: passwordConfirmation
        }
      });
    },
    loadedConstant: _constants.USER_RESET_PASSWORD_SUCCESS,
    errorConstant: _constants.USER_RESET_PASSWORD_ERROR,
    loadingConstant: _constants.USER_RESETTING_PASSWORD
  });
  this.getUserAccessCodeSubmittingKey = function (userId) {
    return "redeem/".concat(userId);
  };
  this.userSubmitAccessCode = (0, _createAction.createApiRequestAction)({
    getKey: this.getUserAccessCodeSubmittingKey,
    request: function request(getState, userId, accessCode) {
      return _this.api.post("access_codes/".concat(accessCode, "/redeem/"), {
        user_id: userId
      });
    },
    loadedConstant: _constants.USER_SUBSCRIPTIONS_FETCHED,
    errorConstant: _constants.USER_ACCESS_CODE_SUBMISSION_ERROR,
    loadingConstant: _constants.USER_LOADING
  });
  this.getUserAccountAuthKey = function () {
    return 'user-account-auth';
  };
  this.userAccountAuth = (0, _createAction.createApiRequestAction)({
    getKey: this.getUserAccountAuthKey,
    request: function request(getState, userId, email, password) {
      return _this.api.post("users/".concat(userId, "/account-auth"), {
        email: email,
        password: password
      });
    },
    loadedConstant: _constants.USER_ACCOUNT_AUTH_SUCCESS,
    errorConstant: _constants.USER_ACCOUNT_AUTH_FAILURE,
    loadingConstant: _constants.USER_LOADING
  });
  this.userForgotPasswordKey = function () {
    return 'user/forgot-password';
  };
  this.userForgotPassword = (0, _createAction.createApiRequestAction)({
    getKey: this.userForgotPasswordKey,
    request: function request(getState, email, examName) {
      return _this.api.post('users/forgot_password', {
        user: {
          email: email
        },
        exam_name: examName
      });
    },
    loadedConstant: _constants.USER_FORGOT_PASSWORD_SENT,
    errorConstant: _constants.USER_FORGOT_PASSWORD_FAILED,
    loadingConstant: _constants.USER_FORGOT_PASSWORD_SENDING
  });
  this.api = api;
});
var _default = exports.default = Users;